import {HttpClient} from "../../service/httpClient/HttpClient";

export class VowService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    addNewVow(title, description, slug, amountPerUnit) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `vow-hosts`,
                {
                    title, description, slug, amountPerUnit
                }
            ).then(resolve).catch(reject)
        })
    }

    getVowList(page, size) {
        return this.httpClient.get(
            `vow-hosts`,
            {
                page, size
            }
        )
    }

    getBasicInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `vow-hosts/${id}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateInformation(id, title, amountPerUnit, slug, description) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `vow-hosts/${id}/information`,
                {
                    title,
                    description,
                    amountPerUnit,
                    slug
                }
            ).then(resolve).catch(reject)
        })
    }

    getVowEnabled(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `vow-hosts/${id}/enabled`
            ).then(resolve).catch(reject)
        })
    }

    updateVowEnabled(id, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `vow-hosts/${id}/enabled`,
                {
                    enabled
                },
            ).then(resolve).catch(reject)
        })
    }

    getVowPayment(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `vow-hosts/${id}/payment-gateway`
            ).then(resolve).catch(reject)
        })
    }

    updateVowGateway(id, paymentGatewayId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `vow-hosts/${id}/payment-gateway`,
                {
                    paymentGatewayId
                }
            ).then(resolve).catch(reject)
        })
    }

    getVowAmountLimit(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `vow-hosts/${id}/amount-limit`
            ).then(resolve).catch(reject)
        })
    }

    updateVoeAmountLimit(id, amountCeiling, amountLimit) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `vow-hosts/${id}/amount-limit`,
                {
                    amountCeiling,
                    amountLimit
                }
            ).then(resolve).catch(reject)
        })
    }

    getVowTimeBaseInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `vow-hosts/${id}/time-base`
            ).then(resolve).catch(reject)
        })
    }

    updateVowTimeBase(id, startDate, endDate, timeBase) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `vow-hosts/${id}/time-base`,
                {
                    timeBase,
                    startDate: startDate,
                    endDate: endDate,
                }
            ).then(resolve).catch(reject)
        })
    }

    getReport(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `vow-hosts/${id}/vows/statistical/summary`
            ).then(resolve).catch(reject)
        })
    }

    getVows(id = -1, page, size, fullName = "", nationalCode = "", phoneNumber = "") {

        let params = {}

        if (id >= 0) {
            params = {
                ...params,
                "vow-host-id": id,
            }
        }

        if (fullName && fullName.length > 0) {
            params = {
                ...params,
                "full-name": fullName,
            }
        }

        if (nationalCode && nationalCode.length > 0) {
            params = {
                ...params,
                "national-code": nationalCode,
            }
        }

        if (phoneNumber && phoneNumber.length > 0) {
            params = {
                ...params,
                "phone-number": phoneNumber,
            }
        }

        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `vows`,
                {
                    page,
                    size,
                    ...params
                }
            ).then(resolve).catch(reject)
        })
    }

    getVowDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `vows/${id}`
            ).then(resolve).catch(reject)
        })
    }
}